import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { UserModel } from 'projects/core/src/lib/models/user.model';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent extends BaseDetail implements OnInit {

  public user: UserModel = null;
  public backRoute = ['/users'];
  public sysMode: string | null = null;

  protected identifier = 'user';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
    private auth: AuthStateService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.sysMode = this.auth.getSysMode();
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('users', params.id).subscribe({
          next: (result: any) => {
            this.user = new UserModel().deserialize(result.data);
            this.setInitialized(DetailModes.edit);
            setTimeout(() => {
              this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.user.id), 10);
            }, 0);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

  onTabChange(event: any): void {
    if (this.user !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.user.id, event.index);
    }
    this.ui.setFocus();
  }

}
